// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__t-779","fileBtn":"File_fileBtn__3Aa6W","closeBtn":"File_closeBtn__5n88b","fileSelected":"File_fileSelected__1jZzD","disabled":"File_disabled__21FHs"};